var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRepo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.619 19H1.80952C0.804233 19 0 18.1958 0 17.1905V1.77601C0 0.804233 0.804233 0 1.80952 0H22.619C23.6243 0 24.4286 0.804233 24.4286 1.80952V17.224C24.4286 18.1958 23.6243 19 22.619 19Z",
    fill: "#0E1E57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37486 2.33248C2.74963 2.33248 3.05343 2.02868 3.05343 1.65391C3.05343 1.27915 2.74963 0.975342 2.37486 0.975342C2.0001 0.975342 1.69629 1.27915 1.69629 1.65391C1.69629 2.02868 2.0001 2.33248 2.37486 2.33248Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36802 2.33248C4.74279 2.33248 5.0466 2.02868 5.0466 1.65391C5.0466 1.27915 4.74279 0.975342 4.36802 0.975342C3.99326 0.975342 3.68945 1.27915 3.68945 1.65391C3.68945 2.02868 3.99326 2.33248 4.36802 2.33248Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40416 2.33248C6.77892 2.33248 7.08273 2.02868 7.08273 1.65391C7.08273 1.27915 6.77892 0.975342 6.40416 0.975342C6.02939 0.975342 5.72559 1.27915 5.72559 1.65391C5.72559 2.02868 6.02939 2.33248 6.40416 2.33248Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53764 8.12766L6.72835 10.1135L9.53764 12.0993L8.77147 12.9787L5.53653 10.6241V9.57447L8.77147 7.24823L9.53764 8.12766Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9712 6H14.1347L11.6375 14H10.4741L12.9712 6Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.752 7.24823L18.987 9.57447V10.6241L15.752 12.9504L14.9858 12.0709L17.7951 10.0851L14.9858 8.09929L15.752 7.24823Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRepo);
export default __webpack_public_path__ + "static/media/Icon-Repo.0cb44805efe499fdc23d59d91ae01262.svg";
export { ForwardRef as ReactComponent };